export function globalFormatDate(value) {
  if (value === 0)
    return "--";

  const now = new Date();
  const date = new Date(value * 1000);

  // if the post happened TODAY, display "Today, time"
  if (now.getYear() == date.getYear() && now.getMonth() == date.getMonth() && now.getDate() == date.getDate())
    return 'Сегодня, ' + date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });

  // if the post happened YESTERDAY, display "Yesterday, time"
  const dateYesterday = new Date((new Date()).valueOf() - 86400000); // 1000 * 60 * 60 * 24 milliseconds
  if (dateYesterday.getYear() == date.getYear() && dateYesterday.getMonth() == date.getMonth() && dateYesterday.getDate() == date.getDate())
    return 'Вчера, ' + date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });

  // if the post happened prior to yesterday, display full date and time
  const options = {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return date.toLocaleString('en-GB', options);
}

export function globalRusDateShort(value) {
  if (value === 0)
    return "--";

    const date = new Date(value * 1000);
    const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    let month = date.getMonth();

    const options = {
      day: '2-digit'
    };
    let day = date.toLocaleString('en-GB', options);
    if (day.charAt(0) === '0') {
      day = day.charAt(1);
    }

    const options2 = {
      hour: '2-digit',
      minute: '2-digit'
    };
    let hours = date.toLocaleString('ru-RU', options2);

    return day + ' ' + MONTHS[month] + ' ' + date.getFullYear();
}

export function globalDateDots(value) {
  if (value === 0)
    return "--";

  const date = new Date(value * 1000);

  // if the post happened prior to yesterday, display full date and time
  const options = {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };
  let result = date.toLocaleString('en-GB', options);
  return result.replaceAll(',','').replaceAll('/','.');
}

export function globalUtcDate(value) {
  if (value === 0)
    return "--";

  const date = new Date(value);

  // if the post happened prior to yesterday, display full date and time
  const options = {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC'
  };
  return date.toLocaleString('en-GB', options);
}

export function globalDateHours(value) {
  if (value === 0)
    return "-";
  const date = new Date(value * 1000);
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });
}
